export default "__VITE_ASSET__f3e94f76__"